var React = require('react');

function InfoV2 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"white","cx":"10","cy":"10","r":"10","key":0}),React.createElement("rect",{"x":"9","y":"9","fill":"#004e37","width":"2","height":"6","key":1}),React.createElement("rect",{"x":"9","y":"5","fill":"#004e37","width":"2","height":"2","key":2})]);
}

InfoV2.defaultProps = {"className":"MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch","focusable":"false","aria-hidden":"true","viewBox":"0 0 20 20","data-testid":"FilterListIcon"};

module.exports = InfoV2;

InfoV2.default = InfoV2;
